// submitPost appends a link's raw URL to the post content as its own
// paragraph — that's the only way the backend's Community::LinkService can
// find a URL to scrape, since a post has no separate structured "link" field.
// Kramdown then renders it as a bare `<p>URL</p>`, which shows up as a plain
// text link in the body even though the same link is already shown as a
// rich card below. Only strip it once we know a card will actually render
// for this post — otherwise the raw link is the only indication of it.
const TRAILING_BARE_URL_PARAGRAPH = /<p>\s*https?:\/\/[^\s<]+\s*<\/p>\s*$/i;

export const stripRedundantLinkParagraph = (html: string): string =>
  html.replace(TRAILING_BARE_URL_PARAGRAPH, "").trim();
